import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full bg-[#FBFBF8]">
      <div className="w-full py-5 border-t-[2px] lg:h-[500px]  flex-wrap px-4 sm:pl-10 sm:pr-8 mt-2 mx-auto flex items-center sm:gap-[20%]">
        <div className="lg:h-[290px] ">
          <div className="sm:pl-4 flex cursor-pointer gap-2 sm:gap-4 items-center">
            <a href="/">
              <img
                src={require("../../Assets/Logo/logo-transparent.png")}
                className="w-[20px] sm:w-[35px] object-contain h-[15px] sm:h-[28px]"
              />
            </a>
            <a href="/">
              <h4 className="font-[500]  text-[12px] sm:text-[26.29px] text-[#000000]">
                Greengate
              </h4>
            </a>
          </div>
        </div>
        <div className="flex flex-wrap lg:h-[290px] gap-5">
          <div className="min-w-[200px]">
            <h3 className="text-[#000000] mt-6 sm:mt-3 md:mt-0 mb-4 font-[600] text-[10px] sm:text-base cursor-pointer">
              Company
            </h3>
            <h4
              onClick={() => {
                navigate("/about-us");
              }}
              className="text-[#000000] my-1 font-[300] text-[10px] sm:text-base cursor-pointer"
            >
              About us
            </h4>
            <h4
              onClick={() => {
                navigate("/about-us");
              }}
              className="text-[#000000] my-1 font-[300] text-[10px] sm:text-base cursor-pointer"
            >
              History
            </h4>
            <h4
              onClick={() => {
                navigate("/products");
              }}
              className="text-[#000000] my-1 font-[300] text-[10px] sm:text-base cursor-pointer"
            >
              Products
            </h4>
          </div>
          <div className="">
            <h3 className="text-[#000000] mt-3 md:mt-0  mb-4 font-[600] text-[10px] sm:text-base cursor-pointer">
              Contact info
            </h3>
            <h4 className="text-[#000000] my-1 font-[300] text-[10px] sm:text-base cursor-pointer">
              Location:
            </h4>
            <h4 className="text-[#000000] mb-3 font-[300] text-[10px] sm:text-base cursor-pointer">
              12 Ipaye Close, Bode Thomas, Surulere, Lagos
            </h4>
            <h4 className="text-[#000000] my3 sm:my-1 font-[300] text-[10px] sm:text-base cursor-pointer">
              Email:
            </h4>
            <a
              target="_blank"
              rel="noreferrer"
              href={"mailto:info.greengatepharma@gmail.com"}
            >
              <h4 className="text-[#000000] mb-3 font-[300] text-[10px] sm:text-base cursor-pointer">
                info.greengatepharma@gmail.com
              </h4>
            </a>
            <h4 className="text-[#000000] my-1 font-[300] text-[10px] sm:text-base cursor-pointer">
              Phone:
            </h4>
            <h4 className="text-[#000000] my-1 font-[300] text-[10px] sm:text-base cursor-pointer">
              +23407046145047
            </h4>
          </div>
        </div>
      </div>
      <div className="w-full py-4 border-t-[2px] sm:h-[70px] flex-wrap  border-t-[rgba(111,108,108,0.11)] px-4 sm:pl-10 sm:pr-8 mt-2 mx-auto flex items-center justify-between">
        <h3 className="text-[#000000] font-[500] text-[10px] sm:text-base ">
          © Greengate {new Date().getFullYear()}. All right reserved
        </h3>
        <div className="flex items-center justify-center gap-3">
          <h4 className="text-[#000000] font-[500] text-[10px] sm:text-base cursor-pointer">
            Facebook{" "}
          </h4>
          <h4 className="text-[#000000] font-[500] text-[10px] sm:text-base cursor-pointer">
            Instagram
          </h4>
          <h4 className="text-[#000000] font-[500] text-[10px] sm:text-base cursor-pointer ">
            Linkedin
          </h4>
        </div>
      </div>
    </div>
  );
};

export default Footer;
